import { DateFilterModel } from '../../../Common/Forms/models/date-filter.model';
import { TopicBackfillApiModel } from '../../../api/backfills/models/topic-backfill.api.model';
export class TopicBackfillModel {
    id: number;
    createdByUserId: number;
    createdDate: Date;
    dateFilter: DateFilterModel;
    folderId: number;
    lastModifiedByUserId: number;
    lastModifiedDate: Date;
    savedSearchId: number;
    totalMentions: number;

    constructor(apiModel: TopicBackfillApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.createdByUserId = apiModel.createdByUserId;
            this.createdDate = new Date(apiModel.createdDate);
            this.dateFilter = apiModel.dateFilter;
            this.folderId = apiModel.folderId;
            this.lastModifiedByUserId = apiModel.lastModifiedByUserId;
            this.lastModifiedDate = new Date(apiModel.lastModifiedDate);
            this.savedSearchId = apiModel.savedSearchId;
            this.totalMentions = apiModel.totalMentions;
        }
    }
}
